module.exports = __webpack_public_path__ + "img/lock-keyhole.d90a79e2.svg";